import React, { useState, useEffect } from "react";
import { buildApiUrl } from '../config';
import "./StockPurchase.css"; // Ensure consistent styling

const StockPurchase = () => {
    const [stockTransactions, setStockTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchStockTransactions();
    }, []);

    const fetchStockTransactions = async () => {
        try {
            const response = await fetch(buildApiUrl("api/stock/transactions"));
            const data = await response.json();

            if (data.success) {
                setStockTransactions(data.data);
            } else {
                setError("Failed to fetch stock Purchase history.");
            }
        } catch (err) {
            console.error("Error fetching Purchase history:", err);
            setError("Error fetching stock Purchase history.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p className="error">{error}</p>;

    return (
        <div className="stock-transactions-container">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                <h1 style={{ margin: 0 }}>Stock Purchase History</h1>
                <button
                    onClick={() => {
                        try {
                            if (!stockTransactions || stockTransactions.length === 0) {
                                alert('No data to export');
                                return;
                            }
                            const headers = ['Date','Category','Brand','Oil Type / Filter No','Quantity','Price (AED)','Payment Method','Supplier'];
                            const rows = stockTransactions.map(t => [
                                t.TransactionDate ?? '-',
                                t.Category ?? '-',
                                t.Brand ?? '-',
                                t.OilType_FilterNo ?? '-',
                                t.Quantity ?? '-',
                                t.Price ?? '-',
                                t.PaymentMethod ?? 'credit',
                                t.SupplierName ?? '-'
                            ]);
                            const csv = [headers, ...rows]
                              .map(row => row.map(cell => {
                                const val = cell === null || cell === undefined ? '' : String(cell);
                                const escaped = val.replace(/"/g, '""');
                                return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
                              }).join(',')).join('\n');
                            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `Stock_Purchase_History_${new Date().toISOString().split('T')[0]}.csv`;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            URL.revokeObjectURL(url);
                        } catch (e) {
                            console.error('Export failed', e);
                            alert('Failed to export CSV');
                        }
                    }}
                    style={{
                        background: 'none',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#217346',
                        padding: '6px 10px'
                    }}
                    title="Export current table to CSV"
                >
                    📊
                </button>
            </div>
            <div className="table-container">
                <table className="styled-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Category</th> {/* ✅ New Column */}
                            <th>Brand</th>
                            <th>Oil Type / Filter No</th> {/* ✅ Renamed Column */}
                            <th>Quantity</th>
                            <th>Price (AED)</th>
                            <th>Payment Method</th>
                            <th>Supplier</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stockTransactions.length > 0 ? (
                            stockTransactions.map((transaction, index) => (
                                <tr key={index}>
                                    <td>{transaction.TransactionDate}</td>
                                    <td>{transaction.Category}</td>
                                    <td>{transaction.Brand}</td>
                                    <td>{transaction.OilType_FilterNo}</td>
                                    <td>{transaction.Quantity}</td>
                                    <td>{transaction.Price}</td>
                                    <td>{transaction.PaymentMethod || 'credit'}</td>
                                    <td>{transaction.SupplierName || "-"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8">No stock transactions found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StockPurchase;
